import PropTypes from 'prop-types';
import React from "react";
import autobind from "autobind-decorator";
import {tsvFormat, csvFormat} from "d3-dsv";

import TriggerMixin from "./Modal.jsx";

import "./ExportModal.css";

class ExportContent extends React.PureComponent {
    render() {
        let {data, mref, formatter} = this.props;
        let props = {
            readOnly: true,
            onClick: e => e.target.select()
        };

        return <textarea ref={mref} value={formatter(data.values())} {...props} />;
    }
}

ExportContent.propTypes = {
    mref: PropTypes.func,
    formatter: PropTypes.func,
    data: PropTypes.object
};

const formatters = {
    'json': data => {
        return data.map(JSON.stringify).join("\n");
    },
    'csv': csvFormat,
    'tsv': tsvFormat
};

export default class ExportModal extends TriggerMixin {
    static defaultProps = {
        title: "Export"
    };

    static propTypes = {
        dataMapper: PropTypes.func.isRequired
    };

    static displayName = 'ExportModal';

    constructor(...args) {
        super(...args);
        this.state = {formatter: 'tsv'};
    }

    shouldComponentUpdate() {
        return this.isOpen();
    }

    @autobind
    onShow() {
        this.forceUpdate(this.focus);
    }

    @autobind
    focus() {
        if (this.field) {
            this.field.focus();
            this.field.select();
        }
    }

    renderContent() {
        let {dataMapper, ...props} = this.props;
        let formatter = formatters[this.state.formatter];

        let Content = dataMapper(ExportContent);
        let option = val => (
            {
                onClick: () =>  this.setState({formatter: val}, this.focus),
                className: "button" + (val == this.state.formatter ? " selected" : "")
            }
        );

        return (
            <div className="export">
                <div className="item">
                    <div className="export-row">
                        <span {...option('tsv')}>tsv</span>
                        <span {...option('csv')}>csv</span>
                        <span {...option('json')}>json</span>
                    </div>

                    <Content
                        {...props}
                        mref={f => this.field = f}
                        formatter={formatter}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/kpi/components/ExportModal.jsx